var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleGradientStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8097 26.8174L15.2131 22.1771C15.141 22.1174 15.1833 22.0002 15.277 22.0002H22.4997L24.9066 14.7793C24.9369 14.6887 25.0647 14.688 25.096 14.7782L27.5975 22.0002H34.7228C34.8165 22.0002 34.8587 22.1173 34.7868 22.1771L29.2014 26.8174L30.9352 33.7424C30.9576 33.832 30.8571 33.9015 30.7812 33.849L25.0056 29.8503L19.2185 33.849C19.1425 33.9015 19.0421 33.8318 19.0647 33.7423L20.8097 26.8174Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 19.2697,
    y1: 10.0059,
    x2: 40.6411,
    y2: 19.9678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3158F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224659,
    stopColor: "#6868FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659007,
    stopColor: "#B45964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36AF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGradientStar);
export default __webpack_public_path__ + "static/media/circle-gradient-star.f1ccac37d4a83feebf017bb55c8a092f.svg";
export { ForwardRef as ReactComponent };